export const GoogleMapApiConfig = 'AIzaSyBaMLYZLpSHEGxSuqVzQZ56avjQG8kHJpY';